import * as Yup from 'yup';

export const REJECT_REASON_GROUPS = [
  { id: 'rejected_by_us', label: 'We rejected them' },
  { id: 'rejected_by_them', label: 'They rejected us' },
  { id: 'other', label: 'Others' },
];

export const createFormFields = [
  {
    name: 'reason',
    label: 'Reason',
    type: 'input',
    maxLength: 255,
    isRequired: true,
    // placeholder: 'Add reason here',
    errorMessage: 'Reason is required',
  },
];

export const moveFormFields = [
  {
    name: 'group',
    label: 'Destination category',
    type: 'select',
    isRequired: true,
    options: REJECT_REASON_GROUPS,
    valueKey: 'id',
    labelKey: 'label',
  },
];

export const deleteFormFields = [
  {
    name: 'deleteInput',
    type: 'input',
    isRequired: true,
    placeholder: 'Type "DELETE"',
    errorMessage: 'Confirmation message is required',
    validation: Yup.string()
      .oneOf(['DELETE'], `Confirmation message doesn't match`)
      .required('Confirmation message is required'),
  },
];
